import Menu from '../../components/Menu';
import { useEffect, useState } from 'react';
import Topo from '../../components/Topo';
import api from '../../services/api';
import dadosPlaca from './dadosPlaca';
import moment from 'moment';

function removeMask(str) {
	str = str.replaceAll('.', '');
	str = str.replaceAll('-', '');
	str = str.replaceAll(' ', '');
	str = str.replaceAll('_', '');
	return str;
}

const convertToCSV = (array) => {
	const csvRows = [];
	const headers = ["CPF", "NOME", "NASC", "CIDADE", "UF"];

	// Adiciona os cabeçalhos
	csvRows.push(headers.join(','));

	// Adiciona os dados
	for (const item of array) {
		const values = headers.map(header => item[header.replace(' ', '')]);
		csvRows.push(values.join(','));
	}
	console.log(csvRows);
	return csvRows.join('\n');
}

const downloadCSV = (data) => {
	const csvData = convertToCSV(data);
	const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
	const link = document.createElement("a");
	const url = URL.createObjectURL(blob);
	link.setAttribute("href", url);
	link.setAttribute("download", `leads_${Date.now()}-${Math.floor(Math.random() * 10000)}.csv`);
	link.style.visibility = 'hidden';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

const copyToClipboard = (data) => {
	const csvData = convertToCSV(data);
	navigator.clipboard.writeText(csvData).then(() => {
		alert('Dados copiados para o Clipboard!');
	}).catch(err => {
		console.error('Erro ao copiar para o Clipboard: ', err);
	});
}

const DadosLayout = ({ dados }) => {
	return (
		<>
			<div class="container" style={{ marginBottom: '8%;' }}>
				<div className='container' style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px' }}>
					<a href="#" onClick={() => downloadCSV(dados)} className="btn btn-secundary bntalt pesquisar" style={{ background: '#1d4ef0', color: '#fff' }}>Exportar CSV</a>
					<a href="#" onClick={() => copyToClipboard(dados)} className="btn btn-dark bntalt pesquisar" style={{ marginLeft: '10px', background: '#2d2d2d', color: '#fff' }}>Copiar</a>
				</div>
			</div>

			<div class="container" style={{ marginBottom: '8%;' }}>
				<form style={{ marginTop: '0', paddingTop: '0' }}>
					<div class="col-md-12">

						<div class="tab-content" id="PesquisaResult">
							<div role="tabpanel" class="tab-pane active" id="home">
								<div class="table-responsive">
									<table id="result" class="table table-bordred table-striped">
										<thead>
											<tr>
												<th>CPF/CNPJ</th>
												<th>Nome / Razão Social</th>
												<th>Nascimento</th>
												<th>Cidade</th>
												<th>UF</th>
											</tr>
										</thead>
										<tbody>
											{dados.map((dado) => {
												return <tr>
													<td><a target='_blank' href={`./Resultado/${removeMask(dado.CPF)}`}>{dado.CPF}</a></td>
													<td>{dado.NOME}</td>
													<td>{moment(dado.NASC).format("DD/MM/YYYY")} {dado.IDADE ? ` (${dado.IDADE} anos)` : ''} </td>
													<td>{dado.CIDADE ? dado.CIDADE : '-'}</td>
													<td>{dado.UF ? dado.UF : '-'}</td>
												</tr>
											})}
										</tbody>
									</table>

								</div>

								<div class="pagnatin">
									<div class="clearfix"></div>


								</div>
							</div>
							<input type="hidden" value="" name="paginas" id="paginas" />
						</div>
					</div>
				</form>
			</div>
		</>
	);
}

function Painel() {
	const [profissao, setProfissao] = useState('');
	const [profissoes, setProfissoes] = useState([]);
	const [checkFaturas, setCheckFaturas] = useState(false);
	const [idFatura, setIdFatura] = useState('');
	const [trava, setTrava] = useState(true);
	const [loading, setLoging] = useState(false);
	const [toggleState, setToggleState] = useState(1);
	var [doc, setDoc] = useState('');
	const [nb, setNb] = useState('');
	const [nome, setNome] = useState('');
	const [telefone, setTelefone] = useState('');
	const [cidade, setCidade] = useState('');
	const [uf, setUf] = useState('');
	const [numero, setNumero] = useState('');
	const [logradouro, setLogradouro] = useState('');

	const [numeroInicial, setNumeroInicial] = useState('');
	const [numeroFinal, setNumeroFinal] = useState('');
	const [checkDividas, setCheckDividas] = useState(false);

	const [idadeInicial, setIdadeInicial] = useState('1');
	const [idadeFinal, setIdadeFinal] = useState('99');

	const [idadeInicialEnd, setIdadeInicialEnd] = useState('1');
	const [idadeFinalEnd, setIdadeFinalEnd] = useState('99');


	const [cep, setCep] = useState('');
	const [email, setEmail] = useState('');
	var [placa, setPlaca] = useState('');
	const [dados, setDados] = useState([]);
	const [dadosPlaca, setDadosPlaca] = useState({});
	const [msg, setMsg] = useState('');
	const [listaDados, setListaDados] = useState([]);

	const [pessoaFisica, setPessoaFisica] = useState(true);
	const [pessoaJuridica, setPessoaJuridica] = useState(true);

	const [pessoaFisicaNome, setPessoaFisicaNome] = useState(true);
	const [pessoaJuridicaNome, setPessoaJuridicaNome] = useState(true);

	const toggleTab = (index) => {
		setToggleState(index);
		setDados([])
		setMsg('');
		setDadosPlaca({});

	};


	const submitDividas = (e) => {
		e.preventDefault(0);
		//	console.log(doc);
		setLoging(true);
		if (doc.length > 0) {
			doc = doc.replace('-', '').replace('.', '').replace('.', '')
			window.location = './Dividas/' + doc;
			return;
		} else {
			setMsg('Digite um documento valido.');
		}
	};

	const submitDoc = (e) => {
		e.preventDefault(0);
		console.log(doc);
		setLoging(true);
		if (doc.length > 0) {
			doc = doc.replace('-', '').replace('.', '').replace('.', '')
			window.location = './Resultado/' + doc;
			return;
		} else {
			setMsg('Digite um documento valido.');
		}
	};

	const submitNb = (e) => {
		var nbb = nb
		e.preventDefault(0);
		setLoging(true);
		//		console.log(nb)
		if (nbb.length > 0) {
			nbb = nbb.replace('-', '').replace('.', '').replace('.', '')
			window.location = './ResultadoNb/' + nbb;
			return;
		} else {
			setMsg('Digite um documento valido.');
		}
	};

	const submitNome = async (e) => {
		e.preventDefault(0);
		setLoging(true);
		setMsg('Aguarde....');
		setDados({});
		setDadosPlaca({});
		try {
			var dados = await api.post("/api/nome", { nome: nome, cidade: cidade, uf: uf, idade_inicial: idadeInicial, idade_final: idadeFinal, pessoa_fisica: String(pessoaFisicaNome), pessoa_juridica: String(pessoaJuridicaNome), profissao: profissao });
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}
		if (dados.data.msg) {
			setMsg(dados.data.msg);
			//			alert(dados.data.msg);
		}
//		if (nome.length > 3) {
			if (dados.data.msg) {
				setMsg(dados.data.msg);
			} else {
				setMsg('');
				setDados(dados.data);

				setListaDados(dados.data);
			}
// 		} else {
// 			setDados({});
// 			setDadosPlaca({});
// 			setListaDados([]);
// 
// 			setMsg('Digite um nome valido.');
// 		}
	};

	const submitTelefone = async (e) => {
		e.preventDefault(0);
		setLoging(true);
		setMsg('Aguarde....');
		setDados({});
		setDadosPlaca({});
		try {
			var dados = await api.post("/api/telefone", { telefone: telefone });
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}

		if (telefone.length > 3) {
			if (dados.data.msg) {
				setMsg(dados.data.msg);
			} else {
				setMsg('');
				setDados(dados.data);
			}
		} else {
			setDados({});
			setDadosPlaca({});

			setMsg('Digite um telefone valido.');
		}
	};

	const submitEndereco = async (e) => {
		e.preventDefault(0);
		setLoging(true);
		setMsg('Aguarde....');
		setDados({});
		setDadosPlaca({});

		try {
			var dados = await api.post("/api/endereco", { numeroInicial: numeroInicial, numeroFinal: numeroFinal, cep:cep, logradouro: logradouro, cidade: cidade, uf: uf, idade_inicial: idadeInicialEnd, idade_final: idadeFinalEnd, pessoa_fisica:  String(pessoaFisica), pessoa_juridica: String(pessoaJuridica) });
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}
		if (dados.data.msg) {
			setMsg(dados.data.msg);
		} else {
			setMsg('');
			setDados(dados.data);
		}
		// 		if(cep.length > 3){
		// 			if(dados.data.msg){
		// 				setMsg(dados.data.msg);				
		// 			}else{
		// 				setMsg('');
		// 				setDados(dados.data);
		// 			}
		// 		}else{
		// 			setDados({});
		// 			setDadosPlaca({});
		// 
		// 			setMsg('Digite um cep valido.');
		// 		}
	};

	const submitEmail = async (e) => {
		e.preventDefault(0);
		setLoging(true);
		setMsg('Aguarde....');
		setDados({});
		setDadosPlaca({});

		try {
			var dados = await api.post("/api/email", { email: email });
		} catch (e) {
			var dados = '';
			setLoging(0);
			setMsg('Indisponivel no momento.');
		}

		if (email.length > 3) {
			if (dados.data.msg) {
				setMsg(dados.data.msg);
			} else {
				setMsg('');
				setDados(dados.data);
			}
		} else {
			setDados({});
			setDadosPlaca({});

			setMsg('Digite um email valido.');
		}
	};

	const submitPlaca = (e) => {
		e.preventDefault(0);
		setLoging(true);
		if (placa.length > 0) {
			placa = placa.replace('-', '').replace('.', '').replace('.', '')
			window.location = './Placa/' + placa;
			return;
		} else {
			setMsg('Digite uma placa valido.');
		}
	};

	function converterData(dataString) {
		const partes = dataString.split('/');
		// new Date(ano, mês, dia) - No JavaScript, os meses são baseados em zero, então é necessário subtrair 1 do mês
		return new Date(partes[2], partes[1] - 1, partes[0]);
	}

	useEffect(() => {
		console.log(listaDados, 'lista no effect');


		const parseDate = (dateStr) => {
			const [day, month, year] = dateStr.split('/').map(Number);
			return new Date(year, month - 1, day); // O mês é 0-indexado em JavaScript
		};

		const isDateEqualOrAfterToday2 = (targetDateStr) => {
			const currentDate = moment().startOf('day'); // Data atual com hora zerada
			const targetDate = moment(targetDateStr, 'DD/MM/YYYY').startOf('day'); // Data fornecida com hora zerada

			// Verificar se a data fornecida é igual ou posterior à data atual
			return targetDate.isSameOrAfter(currentDate);
		};

		const isDateEqualOrAfterToday = (targetDateStr) => {

			// Data no formato "dd/mm/YYYY"
			const dataOriginal = targetDateStr;

			// Converter para objeto Date
			const dataConvertida = converterData(dataOriginal);

			// Data atual
			const dataAtual = new Date();

			// Comparar se a data convertida é menor que a data atual
			if (dataConvertida < dataAtual) {
				return 'vencido'
			} else if (dataConvertida.getTime() === dataAtual.getTime()) {
				return 'vencido';
				//				console.log('A data convertida é igual à data atual.');
			} else {
				return 'ativo';
				//					console.log('A data convertida é posterior à data atual.');
			}
		};
		async function getSair() {
			let dados = await api.get('sair');
			if (dados.data.msg === 'token invalido.') {
				window.localStorage.clear();
				window.location = '../Logue-se';
			} else {
				setMsg(dados.data.msg);
				setTimeout(() => {
					window.localStorage.clear();
					window.location = './';
					//  return ('');
				}, 500);
			}
		}



		const findDadosPerfil = async () => {
			try {
				var dados = await api.get("/perfil");
				//	console.log(dados.data);
				console.log(typeof dados.data.limite_dividas)
				if (typeof dados.data.limite_dividas != 'undefined') {
					setCheckDividas(dados.data.limite_dividas ?? '');
				} else {
					setCheckDividas(false);
				}
				const datevencimento = isDateEqualOrAfterToday(dados.data.vencimento);
				//		console.log(datevencimento);
				if (datevencimento === 'vencido') {
					window.location.href = '/Perfil?msg=cadastro vencido, pague a fatura pendente para continuar...';
					return;
				}
				setTrava(false);
				setCheckFaturas(dados.data.faturaaberta ?? false);
				setIdFatura(dados.data.idfatura ?? '');
			} catch (e) {

				getSair();
				var dados = '';
				setLoging(0);
				setMsg('Indisponivel no momento.');
			}
		}
		findDadosPerfil();


		const findDadosProfissoes = async () => {
			try {
				var dados = await api.get("/api/listaprofissoes");
				//	console.log(dados.data);
			
				setProfissoes(dados.data ?? []);
			} catch (e) {

				getSair();
				var dados = '';
				setLoging(0);
				setMsg('Indisponivel no momento.');
			}
		}
		findDadosProfissoes();

	}, [listaDados]);

	const renderOptions = (selected) => {
		const options = [];
		for (let i = 1; i <= 100; i++) {
			options.push(<option selected={selected == i ? true : false} key={i} value={i}>{i} Anos</option>);
		}
		return options;
	};

	return (
		<>
			<section>
				<Menu />


				<div class="main-content" style={{ marginLeft: '0' }}>
					<div id="page-wrapper">
						<div class="container">
							<Topo />
							<div className="btn-group" role="group" style={{ display: 'flex', justifyContent: 'center', marginTop: '25px' }}>
								<button onClick={() => window.location.href='../../../Painel'} type="button" className="btn btn-default">
									<i className="fa fa-search" style={{ marginRight: '5px', color: '#000' }}></i>
									Leads</button>
								<button onClick={() => window.location.href='../../../Perfil'} type="button" className="btn btn-default">
									<i className="fa fa-address-book" style={{ marginRight: '5px', color: '#000' }}></i>
									Cadastro</button>
								<button onClick={() => window.location.href='../../../Contato'} type="button" className="btn btn-default">
									<i className="fa fa-envelope-o" style={{ marginRight: '5px', color: '#000' }}></i>
									Suporte</button>
							</div>
							<br />
							{trava == false ? <div class="container">
								<div class="col-md-12">
									<div class="card">

										<ul class="nav nav-tabs" role="tablist">
											<li role="presentation" class={toggleState === 1 ? 'active' : ''} onClick={() => toggleTab(1)}>
												<a href="#" aria-controls="documento" role="tab" data-toggle="tab" class="bntmenu" style={{ paddingLeft: '0', paddingRight: '0' }}>
													<i class="fa fa-file-text"></i>&nbsp;
													<span>CPF/CNPJ</span>
												</a>
											</li>
											{checkDividas != false ? (<li style={{ paddingLeft: '0' }} role="presentation" class={toggleState === 9 ? 'active' : ''} onClick={() => toggleTab(9)}>
												<a href="#" aria-controls="documento" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-dollar"></i>&nbsp;
													<span>Dívidas</span>
												</a>
											</li>) : (``)}

											<li role="presentation" class={toggleState === 2 ? 'active' : ''} onClick={() => toggleTab(2)}>
												<a href="#" aria-controls="nome" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-user" aria-hidden="true"></i>
													<span>Nome</span>
												</a>
											</li>
											<li role="presentation" class={toggleState === 3 ? 'active' : ''} onClick={() => toggleTab(3)}>
												<a href="#" aria-controls="telefone" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-phone"></i>
													<span>Telefone</span>
												</a>
											</li>
											<li role="presentation" class={toggleState === 4 ? 'active' : ''} onClick={() => toggleTab(4)}>
												<a href="#" aria-controls="endereceo" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-map-marker" aria-hidden="true"></i>
													<span>Endereço</span>
												</a>
											</li>

											<li role="presentation" class={toggleState === 5 ? 'active' : ''} onClick={() => toggleTab(5)}>
												<a href="#" aria-controls="email" role="tab" data-toggle="tab" class="bntmenu">
													<i class="fa fa-envelope-o" aria-hidden="true"></i>
													<span>E-mail</span>
												</a>
											</li>
											<li role="presentation" style={{ width: '50px', background: '#000', borderTopLeftRadius: '6px', borderTopRightRadius: '6px' }} class={toggleState === 5 ? 'active' : ''} onClick={() => window.location.href = '../../Sair'}>
												<a href="#" aria-controls="email" role="tab" data-toggle="tab" class="bntmenu" style={{ background: '#000', borderRadius: '6px' }}>
													<i class="fa fa-close" aria-hidden="true"></i>

												</a>
											</li>
											{/* <li role="presentation" class={toggleState === 6 ? 'active' : ''} onClick={()=> toggleTab(6)}>
											<a href="#" aria-controls="email" role="tab" data-toggle="tab" class="bntmenu">
												<i class="fa fa-taxi" aria-hidden="true"></i>
												<span>Veiculo</span>
											</a>
										</li> */}
										</ul>

										{checkFaturas == true ? (<div className="alert alert-warning" role="alert" style={{ marginTop: '20px', marginLeft: '5%', marginRight: '5%', marginBottom: '0' }}>
											Existe uma fatura em aberto, <a href={`../../../Faturas/${idFatura}`}>clique aqui</a>
										</div>) : ``}
										<div class="tab-content">


											<div role="tabpanel" class={toggleState === 1 ? 'tab-pane active' : 'tab-pane'} id="documento">
												<form onSubmit={submitDoc} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="CPF/CNPJ" name="doc" id="doc" maxlength="18" value={doc} onChange={(e) => setDoc(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="button" id="pes_doc" onClick={submitDoc}>
																	<span class="glyphicon glyphicon-search"></span>
																</button>
															</span>

														</div>

													</div>
													<span style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'center' }}>Aprimore a eficiência na localização e validação de dados ao inserir o número de CPF, CNPJ ou NB acima.</span>


												</form>

											</div>

											{checkDividas != false ? (
												<div role="tabpanel" class={toggleState === 9 ? 'tab-pane active' : 'tab-pane'} id="documento">
													<form onSubmit={submitDoc} method="POST">
														<div id="custom-search-input">
															<div class="input-group col-md-12">
																<input type="text" class="search-query form-control" placeholder="CPF/CNPJ" name="doc" id="doc" maxlength="18" value={doc} onChange={(e) => setDoc(e.target.value)} />
																<span class="input-group-btn">
																	<button class="btn btn-primary pesquisar" type="button" id="pes_doc" onClick={submitDividas}>
																		<span class="glyphicon glyphicon-search"></span>
																	</button>
																</span>

															</div>

														</div>
														<span style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'center' }}>Localize dívidas de CPF e CNPJ.</span>


													</form>

												</div>) : (``)}

											<div role="tabpanel" id="nome" className={toggleState === 2 ? 'tab-pane active' : 'tab-pane'}>
												<form onSubmit={submitNome} method="POST">
													<div class="form-row">

														<br />
														<span style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'flex-start', marginLeft: '15px' }}>Localização de profissionais e empresas através do nome e cidade e ou profissão.</span>
												
														<div class="form-group col-md-8">
															<span>Digite o nome completo ou razão social</span>
															<input type="text" className="form-control" name="n_nome" id="n_nome" placeholder="Nome completo" value={nome} onChange={(e) => setNome(e.target.value)} />
														</div>
														<div class="form-group col-md-4">
														<span>Profissão</span>
														<select className='form-control' name='profissao' value={profissao} onChange={(e) => setProfissao(e.target.value)}>
														{profissoes.map((profissao) => (
															<option key={profissao.cbo} value={profissao.cbo}>
																{profissao.descricao}
															</option>
														))}	
																<option value="" selected>Todas as opções</option>
															</select>
														</div>



														<div class="form-group col-md-3">
															<span>Idade inicial</span>
															<select className='form-control' onChange={(e) => setIdadeInicial(e.target.value)}>
																{renderOptions(1)}

															</select>
														</div>

														<div class="form-group col-md-3">
															<span>Idade final</span>
															<select className='form-control' onChange={(e) => setIdadeFinal(e.target.value)}>
																{renderOptions(99)}

															</select>
															{/* <input type="number" className="form-control" name="n_idade_final" id="n_idade_final" value={idadeFinal} placeholder="Idade final" onChange={(e) => setIdadeFinal(e.target.value)} /> */}
														</div>
														<div class="form-group col-md-3">
															<span>Cidade</span>
															<input type="text" className="form-control" name="n_cidade" id="n_cidade" value={cidade} placeholder="Cidade" onChange={(e) => setCidade(e.target.value)} />
														</div>
														<div class="form-group col-md-3">
															<span>UF</span>
															{/* <input type="text" className="form-control" name="n_uf" id="n_uf" placeholder="UF" value={uf} onChange={(e) => setUf(e.target.value)} /> */}

															<select className='form-control' name='n_uf' value={uf} onChange={(e) => setUf(e.target.value)}>
																<option value="">Todas</option>
																<option value="AC">Acre</option>
																<option value="AL">Alagoas</option>
																<option value="AP">Amapá</option>
																<option value="AM">Amazonas</option>
																<option value="BA">Bahia</option>
																<option value="CE">Ceará</option>
																<option value="DF">Distrito Federal</option>
																<option value="ES">Espirito Santo</option>
																<option value="GO">Goiás</option>
																<option value="MA">Maranhão</option>
																<option value="MS">Mato Grosso do Sul</option>
																<option value="MT">Mato Grosso</option>
																<option value="MG">Minas Gerais</option>
																<option value="PA">Pará</option>
																<option value="PB">Paraíba</option>
																<option value="PR">Paraná</option>
																<option value="PE">Pernambuco</option>
																<option value="PI">Piauí</option>
																<option value="RJ">Rio de Janeiro</option>
																<option value="RN">Rio Grande do Norte</option>
																<option value="RS">Rio Grande do Sul</option>
																<option value="RO">Rondônia</option>
																<option value="RR">Roraima</option>
																<option value="SC">Santa Catarina</option>
																<option value="SP">São Paulo</option>
																<option value="SE">Sergipe</option>
																<option value="TO">Tocantins</option>
															</select>

														</div>

														{/* <div class="form-group col-md-2" style={{ marginTop: '1px' }}>
															<button type="submit" class="btn btn-primary bntalt pesquisar" id="pes_nome" onClick={submitNome}>Pesquisar</button>
														</div> */}

<div className="form-group col-md-12" style={{ marginTop: '1px;', display: 'flex' }}>
															
														<div style={{paddingRight: '20px', paddingTop: '6px'}}>
															<input checked={pessoaFisicaNome} style={{marginRight: '3px'}} type='checkbox' id='checkbox' value={'pf'} onClick={(e) => setPessoaFisicaNome(!pessoaFisicaNome)}/>
															<label style={{paddingTop: '3px'}} for='checkbox'>Pessoa Física</label>
														
														<input checked={pessoaJuridicaNome} style={{marginRight: '3px', marginLeft: '15px'}} id="checkboxpj" type='checkbox' value={'pj'} onChange={(e) => setPessoaJuridicaNome(!pessoaJuridicaNome)}/>
															<label style={{paddingTop: '3px'}} for="checkboxpj">Pessoa Jurídica</label>
															</div>
															<div>
															<button type="submit" onClick={submitNome} className="btn btn-primary bntalt pesquisar" id="pes_end">Pesquisar</button>
															</div>
														</div>


														<div class="form-group col-md-3">
															
														</div>

													</div>
												</form>
											</div>

											<div role="tabpanel" class={toggleState === 4 ? 'tab-pane active' : 'tab-pane'} id="endereco">
												<form onSubmit={submitEndereco} method="POST">
													<div class="form-row">
														<span style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'flex-start', marginLeft: '15px' }}>Localização de profissionais e empresas através do endereço.</span>

														<div className="form-group col-md-6">
														<span>Logradouro</span>
															<input type="text" className="form-control" id="end_logradouro" name="end_logradouro" placeholder="Logradouro" value={logradouro} onChange={(e) => setLogradouro(e.target.value)} />
														</div>

														<div className="form-group col-md-2">
														<span>CEP</span>
															<input type="text" className="form-control" id="end_cep" name="end_cep" placeholder="CEP" value={cep} onChange={(e) => setCep(e.target.value)} />
														</div>


														<div class="form-group col-md-2">
														<span>Numero inicial</span>
															<input type="number" class="form-control" id="numero_inicial" name="numero_inicial" placeholder="N.º Inicial" value={numeroInicial} onChange={(e) => setNumeroInicial(e.target.value)} />
														</div>
														<div class="form-group col-md-2">
														<span>Numero final</span>
															<input type="number" class="form-control" id="numero_final" name="numero_final" placeholder="N.º Final" value={numeroFinal} onChange={(e) => setNumeroFinal(e.target.value)} />
														</div>
													</div>

													<div class="form-group col-md-3">
															<span>Idade inicial</span>
															<select className='form-control' onChange={(e) => setIdadeInicialEnd(e.target.value)}>
																{renderOptions(1)}

															</select>
														</div>

														<div class="form-group col-md-3">
															<span>Idade final</span>
															<select className='form-control' onChange={(e) => setIdadeFinalEnd(e.target.value)}>
																{renderOptions(99)}

															</select>
															{/* <input type="number" className="form-control" name="n_idade_final" id="n_idade_final" value={idadeFinal} placeholder="Idade final" onChange={(e) => setIdadeFinal(e.target.value)} /> */}
														</div>
												
													<div class="form-row">

														<div className="form-group col-md-4">
														<span>Cidade</span>
															<input type="text" className="form-control" id="end_cidade" name="end_cidade" placeholder="Cidade" value={cidade} onChange={(e) => setCidade(e.target.value)} />
														</div>
														<div className="form-group col-md-2">
														<span>UF</span>
															<input type="text" className="form-control" id="end_uf" name="end_uf" placeholder="UF" value={uf} onChange={(e) => setUf(e.target.value)} />
														</div>
													

														<div className="form-group col-md-12" style={{ marginTop: '1px;', display: 'flex' }}>
															
														<div style={{paddingRight: '20px', paddingTop: '6px'}}>
															<input checked={pessoaFisica} style={{marginRight: '3px'}} type='checkbox' id='checkbox' value={'pf'} onClick={(e) => setPessoaFisica(!pessoaFisica)}/>
															<label style={{paddingTop: '3px'}} for='checkbox'>Pessoa Física</label>
														
														<input checked={pessoaJuridica} style={{marginRight: '3px', marginLeft: '15px'}} for="checkbox" type='checkbox' value={'pj'} onChange={(e) => setPessoaJuridica(!pessoaJuridica)}/>
															<label style={{paddingTop: '3px'}}>Pessoa Jurídica</label>
															</div>
															<div>
															<button type="submit" className="btn btn-primary bntalt pesquisar" id="pes_end">Pesquisar</button>
															</div>
														</div>
													</div>
												</form>
											</div>

											<div role="tabpanel" class={toggleState === 3 ? 'tab-pane active' : 'tab-pane'} id="telefone">
												<form onSubmit={submitTelefone} method="POST">
													<div id="custom-search-input">


														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="(12) 3456-7890" name="n_tel" id="n_tel" value={telefone} onChange={(e) => setTelefone(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="submit" id="pes_fone">
																	<span class=" glyphicon glyphicon-search"></span>
																</button>
															</span>
														</div>
													</div>
													<span style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'center' }}>Localização de profissionais e empresas através do DDD e número de telefone.</span>

												</form>
											</div>

											<div role="tabpanel" class={toggleState === 5 ? 'tab-pane active' : 'tab-pane'} id="email">
												<form onSubmit={submitEmail} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="algo@hotmail.com" name="n_email" id="n_email" value={email} onChange={(e) => setEmail(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="submit" id="pes_email">
																	<span class=" glyphicon glyphicon-search"></span>
																</button>
															</span>
														</div>
													</div>
													<span style={{ fontSize: '0.8rem', display: 'flex', justifyContent: 'center' }}>Localização de profissionais e empresas por meio do endereço de e-mail.</span>

												</form>
											</div>
											<div role="tabpanel" class={toggleState === 6 ? 'tab-pane active' : 'tab-pane'} id="placa">
												<form onSubmit={submitPlaca} method="POST">
													<div id="custom-search-input">
														<div class="input-group col-md-12">
															<input type="text" class="search-query form-control" placeholder="Digite a PLACA" name="n_email" id="n_email" value={placa} onChange={(e) => setPlaca(e.target.value)} />
															<span class="input-group-btn">
																<button class="btn btn-primary pesquisar" type="submit" id="pes_email">
																	<span class=" glyphicon glyphicon-search"></span>
																</button>
															</span>

														</div>

													</div>

												</form>
											</div>
										</div>
									</div>
								</div>
							</div> : (``)}
							{msg.length > 0 ? <center>{msg}</center> : ''}

							{dados.length > 0 ? <DadosLayout dados={dados} /> : null}
							{dadosPlaca.length > 0 ? '' : <dadosPlaca dadosPlaca={dadosPlaca} />}
							{/* {listaDados.length > 0 ? <dadosLista dados={listaDados}/> : null} */}








						</div>
					</div>
				</div>
			</section>
		</>

	)
}

export default Painel;
